import { ComponentClassNames } from '../../util/classNames';
import { getPaddingStyles } from '../../util/styles/padding';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { FlexItemProps } from './Flex.types';

type FlexItemClassNames = ComponentClassNames<'flexItem'>;
type FlexItemClassNameProps = Omit<FlexItemProps, 'ariaHidden'>;
type GetFlexItemClassNames = (props: FlexItemClassNameProps) => FlexItemClassNames;

export const getClassNames: GetFlexItemClassNames = memoizeFunction(
  ({
    alignSelf,
    basis: flexBasis,
    grow: flexGrow = 0,
    shrink: flexShrink = 1,
    order,
    height,
    minHeight,
    maxHeight,
    width,
    /**
     * This is required for nested ellipsed text to work within a FlexItem.
     * https://css-tricks.com/flexbox-truncated-text/
     */
    minWidth = 0,
    maxWidth,
    className,
    ...paddingProps
  }) =>
    mergeStyleSets({
      flexItem: [
        {
          alignSelf,
          flexBasis,
          flexGrow,
          flexShrink,
          order,
          height,
          minHeight,
          maxHeight,
          width,
          minWidth,
          maxWidth,
          ...getPaddingStyles(paddingProps),
        },
        className,
      ],
    })
);
